import { matchPath } from "react-router";
import { routesMap } from "../routesMap";

function extractCurrentFileId(pathname: string) {
  for (const route of Object.values(routesMap)) {
    // Only check routes that have entity metadata
    if ("meta" in route && route.meta?.entityType && route.meta?.paramName) {
      const match = matchPath(route.path, pathname);

      if (match?.params) {
        const paramName = route.meta.paramName;
        const entityId = match.params[paramName];

        if (entityId && typeof entityId === "string") {
          return entityId;
        }
      }
    }
  }

  return null;
}

export { extractCurrentFileId };
